import { normalizeProjectPath, splitPath } from "./build.js";
export const ENTITY_TAB_ROUTE_SEGMENT = "tab";
export function parseEntityTabSuffix(segments) {
    if (segments.length < 2) {
        return null;
    }
    const modeSegment = segments[segments.length - 2];
    const valueSegment = segments[segments.length - 1];
    if (modeSegment !== ENTITY_TAB_ROUTE_SEGMENT || !valueSegment) {
        return null;
    }
    return { baseSegmentCount: segments.length - 2, tabSlug: valueSegment };
}
export function stripEntityTabPathSuffix(path) {
    const rawSegments = splitPath(path);
    const decodedSegments = rawSegments.map((segment) => decodeURIComponent(segment));
    const suffix = parseEntityTabSuffix(decodedSegments);
    if (!suffix) {
        return normalizeProjectPath(path);
    }
    return normalizeProjectPath(`/${rawSegments.slice(0, suffix.baseSegmentCount).join("/")}`);
}
export function buildEntityTabPath(baseEntityPath, tabSlug) {
    const base = stripEntityTabPathSuffix(baseEntityPath);
    return normalizeProjectPath(`${base}/${ENTITY_TAB_ROUTE_SEGMENT}/${encodeURIComponent(tabSlug)}`);
}
